var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c(
        "modal",
        {
          attrs: { show: _vm.showEditCompanyModal },
          on: {
            "update:show": function ($event) {
              _vm.showEditCompanyModal = $event
            },
          },
        },
        [
          _c("template", { slot: "header" }, [
            _c(
              "h5",
              {
                staticClass: "modal-title",
                attrs: { id: "exampleModalLabel" },
              },
              [_vm._v("Set Company Details")]
            ),
          ]),
          _c("AssignCompany", {
            on: {
              closeClicked: function ($event) {
                _vm.showEditCompanyModal = false
              },
              saveClicked: function ($event) {
                return _vm.alert("ddd")
              },
            },
          }),
        ],
        2
      ),
      _c("notifications"),
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c("ProjectNavBar", {
            on: {
              calendarClicked: function ($event) {
                return _vm.handleCalendarClicked()
              },
              userClicked: function ($event) {
                return _vm.handleUserClicked()
              },
              headerLoginClicked: _vm.onHeaderLoginClicked,
              detailClicked: function ($event) {
                return _vm.handleDetailClicked()
              },
            },
          }),
          _c("ProjectsHome", {
            attrs: { projectCreateFlag: _vm.projectCreateFlag },
            on: {
              dblClick: _vm.handleTaskDblClick,
              taskDblClick: _vm.handleTaskDblClick,
              assignedByUserClicked: _vm.handleAssignedByUserClicked,
              loginClicked: _vm.handleLoginClick,
            },
          }),
          _c(
            "SidebarRight",
            {
              class: [
                "navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--400",
                { open: _vm.showSideBar },
              ],
              on: { overlayClicked: _vm.outside },
            },
            [
              _c(_vm.currentView, {
                tag: "component",
                attrs: {
                  editId: _vm.editId,
                  showSideBar: _vm.showSideBar,
                  data: _vm.data,
                  profile: _vm.profile,
                },
                on: {
                  projectCreated: _vm.onProjectCreated,
                  iAmNewClicked: _vm.handleIAmNewClicked,
                  backClickedFromRegister: function ($event) {
                    _vm.currentView = "Login"
                  },
                  backClickedFromForgot: function ($event) {
                    _vm.currentView = "Login"
                  },
                  forgotPasswordLinkClicked: function ($event) {
                    _vm.currentView = "Forgot"
                  },
                  registerSuccess: _vm.onRegisterSuccess,
                  verificationNeeded: _vm.onVerificationNeeded,
                  resetPasswordSuccess: _vm.onResetPasswordSuccess,
                  userVerified: _vm.onUserVerificationSuccess,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }